import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';

import { decodeToken } from './utils/jwt.utils';

const PostHogPageViewTracker = () => {
  const location = useLocation();
  const postHog = usePostHog();

  useEffect(() => {
    try {
      if (!postHog) return;

      const posthogDetails = localStorage.getItem('posthogdetails');
      const token = localStorage.getItem('token');

      if (posthogDetails) {
        const posthogDetailsParsed = JSON.parse(posthogDetails);
        postHog.capture('$pageview', {
          viewAsUserName: posthogDetailsParsed?.userProperties?.viewAsUserName || "",
          viewAsUserEmail: posthogDetailsParsed?.userProperties?.viewAsUserEmail || "",
          internalTeam: posthogDetailsParsed?.userProperties?.internalTeam || false,
        });
      } else if (token) {
        let internalTeam = false;
        try {
          const { isStaff } = decodeToken(token);
          internalTeam = isStaff;
        } catch {
          // Token is invalid/corrupted — skip internalTeam flag
        }
        postHog.capture('$pageview', {
          internalTeam: internalTeam,
        });
      }
    } catch {
    }
  }, [location, postHog]);

  return null;
};
export default PostHogPageViewTracker;
